import React from "react"
import { motion } from "framer-motion"
import { cn } from "../lib/utils"

/**
 * BorderBeam - Animated beam of light that travels along the border
 * Based on Magic UI Border Beam component
 */
export function BorderBeam({
  className,
  size = 50,
  delay = 0,
  duration = 6,
  colorFrom = "#ffffff",
  colorTo = "#ffffff",
  transition,
  style,
  reverse = false,
  initialOffset = 0,
  borderWidth = 1,
  borderRadius,
}) {
  // Detect if rounded-full is in className or use provided borderRadius
  const isPill = className?.includes('rounded-full') || borderRadius === 'full';
  const radius = isPill ? 9999 : (borderRadius || size);
  
  const MotionDiv = motion.div;

  return (
    <div
      className="pointer-events-none absolute inset-0 rounded-[inherit] border-[length:var(--border-beam-width)] border-transparent [mask-image:linear-gradient(transparent,transparent),linear-gradient(#000,#000)] [mask-composite:intersect] [mask-clip:padding-box,border-box]"
      style={
        {
          "--border-beam-width": `${borderWidth}px`,
        }
      }
    >
      <MotionDiv
        className={cn(
          "absolute aspect-square bg-gradient-to-l",
          className || "from-[var(--color-from)] via-[var(--color-to)] to-transparent"
        )}
        style={
          {
            width: size,
            offsetPath: `rect(0 auto auto 0 round ${radius}px)`,
            "--color-from": colorFrom,
            "--color-to": colorTo,
            ...style,
          }
        }
        initial={{ offsetDistance: `${initialOffset}%` }}
        animate={{
          offsetDistance: reverse
            ? [`${100 - initialOffset}%`, `${-initialOffset}%`]
            : [`${initialOffset}%`, `${100 + initialOffset}%`],
        }}
        transition={{
          repeat: Infinity,
          ease: "linear",
          duration,
          delay: -delay,
          ...transition,
        }}
      />
    </div>
  )
}
